<template>
  <div class="profile-view">
    <StudentSettings
      v-if="userRole === 'student'"
      :user-role="userRole"
      :is-active-kiosk-module="isActiveKioskModule"
      :show-photo="showStudentPhotos"
      :user="user"
    />
    <AdminSettings
      v-if="loading && userRole !== 'student'"
      :active-appoinment-module-options="activeAppoinmentModuleOptions"
      :is-active-appoinment-module="isActiveAppoinmentModule"
      :is-active-auto-check-in-module="isActiveAutoCheckInModule"
      :user="user"
      :user-role="userRole"
    />
  </div>
</template>

<script>
import AdminSettings from "@/components/UserSettings/AdminSettings.vue"
import StudentSettings from "@/components/UserSettings/StudentSettings.vue"
import { mapGetters } from "vuex"

export default {
  name: "UserSettings",
  components: {
    AdminSettings,
    StudentSettings
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: "authentication/user",
      userRole: "authentication/getUserRole",
      isActiveAppoinmentModule: "schools/isActiveAppoinmentModule",
      isActiveAutoCheckInModule: "schools/isActiveAutoCheckInModule",
      isActiveKioskModule: "schools/isActiveKioskModule",
      activeAppoinmentModuleOptions: "schools/activeAppoinmentModuleOptions",
      showStudentPhotos: "schools/showStudentPhotos"
    })
  },
  created() {
    this.$store.dispatch("authentication/getUserSettings").then(() => {
      this.loading = true
    })
  }
}
</script>

<style></style>
